/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, Jan 2023
 * @flow
 */

import React from 'react';
import Header from '../Header';
import Layout from '../Layout';
import classes from './Body.module.css';
import BookingList from '../BookingList';

const Body = ({
  shapes,
  onSelectShape,
  onOpenSensorGroupPopup,
  selectedSensorGroup,
  bookingStatus,
  onChangeBookingStatus,
  openPopup,
  bookingList,
  onBookingActionClick,
  onMoveBooking,
  onSelectSensorGroup,
  selectedItem,
  selectedShape,
  closeShapeInfoPopup,
  openMergeStationPopup,
  invokeTableUnmerge,
  stationMap,
  onHeaderMenuOptionClick,
  onToggleCheckDetailsPopup,
  onClickSms,
  selectedTableChecks,
  showHelpPopup,
  transferTable,
  openTableMenu,
  onVoidCheck,
  isEnabledDragDrop,
  onToggleDrapDrop,
}) => {
  return (
    <div>
      <Header
        openPopup={openPopup}
        onOpenSensorGroupPopup={onOpenSensorGroupPopup}
        selectedSensorGroup={selectedSensorGroup}
        bookingStatus={bookingStatus}
        onChangeBookingStatus={onChangeBookingStatus}
        onSelectSensorGroup={onSelectSensorGroup}
        onHeaderMenuOptionClick={onHeaderMenuOptionClick}
        showHelpPopup={showHelpPopup}
        isEnabledDragDrop={isEnabledDragDrop}
        onToggleDrapDrop={onToggleDrapDrop}
      />
      <div className={classes.bodyWrapper}>
        <Layout
          shapes={shapes}
          onSelectShape={onSelectShape}
          selectedItem={selectedItem}
          selectedShape={selectedShape}
          closeShapeInfoPopup={closeShapeInfoPopup}
          openMergeStationPopup={openMergeStationPopup}
          invokeTableUnmerge={invokeTableUnmerge}
          onClickInfo={onToggleCheckDetailsPopup}
          onClickSms={onClickSms}
          selectedTableChecks={selectedTableChecks}
          showHelpPopup={showHelpPopup}
          transferTable={transferTable}
          openTableMenu={openTableMenu}
          onVoidCheck={onVoidCheck}
        />
        <div className={classes.detailsWrapper}>
          <BookingList
            bookingList={bookingList}
            openPopup={openPopup}
            onBookingActionClick={onBookingActionClick}
            onMoveBooking={onMoveBooking}
            stationMap={stationMap}
            isEnabledDragDrop={isEnabledDragDrop}
          />
        </div>
      </div>
    </div>
  );
};

export default Body;
